import { render, staticRenderFns } from "./purchase-unit-select.vue?vue&type=template&id=52341e19&scoped=true&"
import script from "./purchase-unit-select.vue?vue&type=script&lang=ts&"
export * from "./purchase-unit-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52341e19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
